import React, { useState } from 'react';
import { UserCircleDisplay } from '../../utils/UserCustomDisplay';
import { StatusBadge, StatusBadgeSm, getStatusClassAndText } from '../../utils/StatusBadge';
import DocumentStatusTable from './DocumentStatusTable';
import TrimContent from '../../utils/TrimContent';
import { useTimezone } from '../../utils/TimezoneContext';

const UnstructuredThreadDetails = ({ threadDetails, onClose, onRefresh }) => {
  // Add refresh trigger state
  const [documentRefreshTrigger, setDocumentRefreshTrigger] = useState(0);
  const { formatDateTime } = useTimezone();
  
  if (!threadDetails) return null;
  
  const { thread, documents } = threadDetails;
  const threadStatus = getStatusClassAndText(thread.upload_status);

  // Combined refresh handler
  const handleRefresh = () => {
    // Call parent's refresh function to update thread details
    onRefresh();
    // Increment refresh trigger to update document table
    setDocumentRefreshTrigger(prev => prev + 1);
  };

  const handleDocumentsUpdated = (documents) => {
    // use this callback if we need to update the parent component
    // or perform any actions when documents are refreshed
    //below function if uncommented will also refresh global thread details component
    //if (onRefresh) {
     // onRefresh(thread.id);
    //}
  };
  
  return (
    <div className="ev-card-4 w-100 ev-padding-xlarge2">
      <div className="text-end">
        <button className="ev-btn-lightblue-fill-round ev-bold-reg ms-2" onClick={handleRefresh}>
          <i className="bi bi-arrow-repeat"></i> Refresh
        </button>
        <button className="ev-btn-blue-outline-round ms-2" onClick={onClose}>
          <i className="bi bi-x-lg"></i> Close
        </button>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-4 mt-2">
        <p className="ev-med-p-blue mb-0 col-4">
           {thread.name}
           &nbsp;
          <span className={`badge badge-sm ${thread.thread_access_level === 'PUBLIC' ? 'bg-primary' : 'bg-danger'}`}>
            {thread.thread_access_level}
          </span>
          <br />
          <span className="ev-small-p-dark">Data Collection Owner </span><span className="ev-message-card1 ev-btn-small mt-2 ">{thread.created_by_email}</span>
        </p>

        <div className="ev-card-2 ev-small-p-dark col-4 me-2">
          <p className="mb-1"><strong>Created at. </strong> {formatDateTime(thread.created_at)}</p>
          <p className="mb-2"><strong>Updated at. </strong> {thread.updated_at ? formatDateTime(thread.updated_at) : 'No Update'}</p>
        </div>

        {thread.thread_access_level === 'PRIVATE' && thread.user_access && thread.user_access.length > 0 && (
          <div className="ev-card-2 col-4">
            <div className="card-body">
              <p className="ev-small-p-dark mb-1">Private User Access</p>
              <UserCircleDisplay users={thread.user_access} maxDisplay={4} />
            </div>
          </div>
        )}
      </div>
      
      <div className="row d-flex mb-4">
        <div className="col-4 d-flex">
          <div className="ev-card-2 mb-3 w-100">
            <p className="ev-small-p-dark mb-1">Meta Tags</p>
            {thread.tags && thread.tags.length > 0 && (
              <div className="d-flex flex-wrap gap-1">
                {thread.tags.map((tag, idx) => (
                  <span key={idx} className="ev-message-card3 ev-btn-small">{tag}</span>
                ))}
              </div>
            )}
          </div>
        </div>
        
        <div className="col-8 d-flex">
          <div className="ev-card-1 mb-3 w-100">
            <div className="card-body">
              <h5 className="ev-reg-p-blue">Overall Status</h5>
              <div className="d-flex justify-content-between align-items-cente">
                <p className="ev-small-p-dark">Migration Status <br /><StatusBadgeSm status={thread.upload_status } /></p>
                <p className="ev-small-p-dark">Standardization <br /><StatusBadgeSm status={thread.standardization_status} /></p> 
                <p className="ev-small-p-dark">Markdown RAG <br /><StatusBadgeSm status={thread.markdown_rag_status} /></p> 
                <p className="ev-small-p-dark">Image RAG <br /><StatusBadgeSm status={thread.image_rag_status} /></p> 
                <p className="ev-small-p-dark">Auto-classification <br /><StatusBadgeSm status={thread.autoclassification_status} /></p>
                <p className="ev-small-p-dark">Parquet <br /><StatusBadgeSm status={thread.parquet_status} /></p> 
              </div>
            </div>
          </div>
        </div>
      </div>
      <DocumentStatusTable 
        threadId={thread.id}
        onDocumentsUpdated={handleDocumentsUpdated}
        externalRefreshTrigger={documentRefreshTrigger}
        onThreadStatusRefresh={handleRefresh}
        
      />
    </div>
  );
};

export default UnstructuredThreadDetails;